(function () {
//   var bar = document.getElementById('cart-step-bar');
//   if (!bar) return;

//   var panel1 = document.getElementById('cart-panel-1');
//   var panel2 = document.getElementById('cart-panel-2');
//   var panels = [panel1, panel2].filter(Boolean);
//   var barItems = Array.prototype.slice.call(bar.querySelectorAll('[data-step]'));
//   var registerBlock = document.getElementById('CartRegisterBlock');
//   var registerCol = document.getElementById('CartRegisterCol');
//   var registerTrigger = document.getElementById('CartRegisterTrigger');
//   var registerTriggerCol = document.getElementById('CartRegisterTriggerCol');
//   var loginCol = document.getElementById('CartLoginCol');
//   var recoverBlock = document.getElementById('CartRecoverBlock');
//   var loginBlock = document.getElementById('CartLoginBlock');
//   var loginValidMessage = document.getElementById('CartLoginValidMessage');
//   var registerValidMessage = document.getElementById('CartRegisterValidMessage');

//   function toggleHiddenClass(el, shouldHide) {
//     if (!el) return;
//     el.classList.toggle('hidden', shouldHide);
//   }

//   function setRegisterMode(isRegisterMode) {
//     toggleHiddenClass(registerCol, !isRegisterMode);
//     toggleHiddenClass(registerBlock, !isRegisterMode);
//     toggleHiddenClass(registerTrigger, isRegisterMode);
//     toggleHiddenClass(registerTriggerCol, isRegisterMode);
//     toggleHiddenClass(loginCol, isRegisterMode);
//     if (!isRegisterMode) {
//       toggleHiddenClass(registerValidMessage, true);
//     }
//     toggleHiddenClass(loginValidMessage, true);
//   }

//   document.addEventListener('submit', function (e) {
//     var form = e.target;
//     if (!form) return;

//     if (form.id === 'CartLoginForm') {
//       e.preventDefault();
//       e.stopPropagation();
//       toggleHiddenClass(loginValidMessage, true);

//       if (!form.checkValidity()) {
//         form.reportValidity();
//         return;
//       }

//       toggleHiddenClass(loginValidMessage, false);
//       return;
//     }

//     if (form.id === 'CartRegisterForm') {
//       e.preventDefault();
//       e.stopPropagation();
//       toggleHiddenClass(registerValidMessage, true);

//       if (!form.checkValidity()) {
//         form.reportValidity();
//         return;
//       }

//       toggleHiddenClass(registerValidMessage, false);
//     }
//   }, true);

//   function goTo(step) {
//     panels.forEach(function (p, i) { p.hidden = (i + 1 !== step); });
//     if (step === 2) {
//       setRegisterMode(false);
//     }
//     barItems.forEach(function (item) {
//       var n = parseInt(item.getAttribute('data-step'), 10);
//       item.classList.remove('is-current', 'is-completed');
//       if (n < step) item.classList.add('is-completed');
//       else if (n === step) item.classList.add('is-current');
//     });
//     var top = bar.getBoundingClientRect().top + window.pageYOffset - 80;
//     window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
//   }

//   document.addEventListener('click', function (e) {
//     var showRegisterEl = e.target.closest('[data-cart-show-register]');
//     if (showRegisterEl) {
//       setRegisterMode(true);
//       return;
//     }

//     var hideRegisterEl = e.target.closest('[data-cart-hide-register]');
//     if (hideRegisterEl) {
//       setRegisterMode(false);
//       return;
//     }

//     var showRecoverEl = e.target.closest('[data-cart-show-recover]');
//     if (showRecoverEl) {
//       toggleHiddenClass(recoverBlock, false);
//       toggleHiddenClass(loginBlock, true);
//       return;
//     }

//     var hideRecoverEl = e.target.closest('[data-cart-hide-recover]');
//     if (hideRecoverEl) {
//       toggleHiddenClass(recoverBlock, true);
//       toggleHiddenClass(loginBlock, false);
//       return;
//     }

//     var goToEl = e.target.closest('[data-cart-go]');
//     if (goToEl) {
//       goTo(parseInt(goToEl.dataset.cartGo, 10));
//     }
//   });

//   goTo(1);
})();


document.addEventListener('DOMContentLoaded', function () {
  const params = new URLSearchParams(window.location.search);
  const isCart = window.location.pathname === '/cart';
  const stepBar = document.querySelector('.cart-step-bar');

  if (!stepBar) return;

  const shouldShow = params.has('checkout_url') || params.has('return_to') || isCart;

  stepBar.classList.toggle('hidden', !shouldShow);
});